import React, { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
import { motion } from 'framer-motion';
import { PricingSelector } from './PricingSelector';
export function Offer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 44,
    seconds: 32
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };else if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };else if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const comparison = [{
    label: 'Preparación semanal',
    sin: '2-3hs buscando en YouTube',
    con: '10 min mirando la planilla'
  }, {
    label: 'Llegada a la práctica',
    sin: 'Sin saber qué vas a hacer',
    con: 'Con la práctica armada'
  }, {
    label: 'Progreso de los pibes',
    sin: 'Siempre los mismos ejercicios',
    con: 'Progresión estructurada'
  }, {
    label: 'Consulta de un padre',
    sin: 'Respuesta improvisada',
    con: 'Datos concretos en la mano'
  }, {
    label: 'Preparación física',
    sin: 'Sin criterio por edad',
    con: 'Rutinas seguras por categoría'
  }, {
    label: 'Fin de temporada',
    sin: 'Sin registros de nada',
    con: 'Evaluación completa de todo'
  }, {
    label: 'Estructura táctica',
    sin: 'Cada partido es diferente',
    con: 'Sistema instalado y progresivo'
  }];
  const TimeBox = ({
    value,
    label,
    accent = false
  }: {
    value: number;
    label: string;
    accent?: boolean;
  }) => <div className="bg-gray-900 border border-gray-700 rounded-lg w-14 md:w-16 py-1.5 md:py-2" data-id="element-80">
      <div className={`font-display text-2xl md:text-3xl ${accent ? 'text-brand-orange' : 'text-white'}`} data-id="element-81">
        {String(value).padStart(2, '0')}
      </div>
      <div className="text-[9px] md:text-[10px] text-gray-500 uppercase font-bold" data-id="element-82">
        {label}
      </div>
    </div>;
  return <section id="pricing" className="bg-brand-cream py-12 md:py-20" data-id="element-83">
      <div className="max-w-6xl mx-auto px-4" data-id="element-84">
        {/* Comparison */}
        <div className="mb-12 md:mb-24" data-id="element-85">
          <div className="text-center mb-6 md:mb-12" data-id="element-86">
            <h3 className="text-brand-orange font-bold tracking-widest uppercase text-xs md:text-sm mb-2" data-id="element-87">
              La Realidad
            </h3>
            <h2 className="font-display text-3xl md:text-5xl text-brand-dark leading-tight" data-id="element-88">
              ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-hidden bg-white rounded-2xl shadow-sm border border-gray-200" data-id="element-89">
            <table className="w-full" data-id="element-90">
              <thead data-id="element-91">
                <tr className="bg-gray-50 border-b border-gray-200" data-id="element-92">
                  <th className="py-4 px-6 text-left font-bold text-gray-500 uppercase tracking-wider text-sm w-1/3" data-id="element-93">
                    Situación
                  </th>
                  <th className="py-4 px-6 text-left font-bold text-red-500 uppercase tracking-wider text-sm w-1/3" data-id="element-94">
                    Sin el sistema
                  </th>
                  <th className="py-4 px-6 text-left font-bold text-green-600 uppercase tracking-wider text-sm w-1/3 bg-green-50/50" data-id="element-95">
                    Con el sistema
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100" data-id="element-96">
                {comparison.map((row, i) => <tr key={i} className="hover:bg-gray-50/50 transition-colors" data-id="element-97">
                    <td className="py-4 px-6 font-semibold text-gray-800" data-id="element-98">
                      {row.label}
                    </td>
                    <td className="py-4 px-6 text-gray-500" data-id="element-99">
                      <div className="flex items-center gap-2" data-id="element-100">
                        <X size={16} className="text-red-400 shrink-0" data-id="element-101" />
                        <span data-id="element-102">{row.sin}</span>
                      </div>
                    </td>
                    <td className="py-4 px-6 font-bold text-green-700 bg-green-50/30" data-id="element-103">
                      <div className="flex items-center gap-2" data-id="element-104">
                        <Check size={18} className="text-green-500 shrink-0" data-id="element-105" />
                        <span data-id="element-106">{row.con}</span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile Stacked Cards */}
          <div className="md:hidden space-y-2" data-id="element-107">
            {comparison.map((row, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-108">
                <div className="bg-gray-50 px-3 py-1.5 font-bold text-brand-dark text-xs border-b border-gray-100" data-id="element-109">
                  {row.label}
                </div>
                <div className="grid grid-cols-2 divide-x divide-gray-100" data-id="element-110">
                  <div className="p-2.5 flex items-start gap-1.5" data-id="element-111">
                    <X size={12} className="text-red-400 shrink-0 mt-0.5" data-id="element-112" />
                    <span className="text-[11px] text-gray-500 leading-snug" data-id="element-113">
                      {row.sin}
                    </span>
                  </div>
                  <div className="p-2.5 flex items-start gap-1.5 bg-green-50/40" data-id="element-114">
                    <Check size={12} className="text-green-500 shrink-0 mt-0.5" data-id="element-115" />
                    <span className="text-[11px] font-bold text-green-700 leading-snug" data-id="element-116">
                      {row.con}
                    </span>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        {/* Countdown Banner */}
        <div className="bg-brand-dark rounded-2xl p-4 md:p-8 mb-6 md:mb-10 flex flex-col md:flex-row items-center justify-between border border-gray-800 shadow-2xl relative overflow-hidden gap-4 md:gap-0" data-id="element-117">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-orange to-brand-gold" data-id="element-118"></div>

          <div className="text-center md:text-left" data-id="element-119">
            <div className="inline-flex items-center gap-2 bg-red-500/20 text-red-400 px-3 py-1 rounded-full text-[10px] md:text-xs font-bold uppercase tracking-wider mb-2 md:mb-3" data-id="element-120">
              <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-121"></span>
              Oferta en vivo
            </div>
            <h3 className="text-white font-display text-xl md:text-3xl" data-id="element-122">
              +$10.000 DESPUÉS
            </h3>
            <p className="text-gray-400 font-medium text-xs md:text-sm" data-id="element-123">
              Y no vuelve a bajar
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end w-full md:w-auto" data-id="element-124">
            <div className="text-gray-400 text-[10px] md:text-xs font-bold uppercase tracking-widest mb-2" data-id="element-125">
              Lanzamiento termina en
            </div>
            <div className="flex gap-2 md:gap-3 text-center" data-id="element-126">
              <TimeBox value={timeLeft.hours} label="Horas" data-id="element-127" />
              <div className="text-xl md:text-2xl text-gray-600 font-display pt-1.5 md:pt-2" data-id="element-128">
                :
              </div>
              <TimeBox value={timeLeft.minutes} label="Min" data-id="element-129" />
              <div className="text-xl md:text-2xl text-gray-600 font-display pt-1.5 md:pt-2" data-id="element-130">
                :
              </div>
              <TimeBox value={timeLeft.seconds} label="Seg" accent data-id="element-131" />
            </div>
            <div className="w-full mt-3 md:mt-4 max-w-xs md:max-w-none" data-id="element-132">
              <div className="flex justify-between text-[10px] md:text-xs text-gray-400 font-bold mb-1" data-id="element-133">
                <span data-id="element-134">Cupos restantes</span>
                <span className="text-brand-orange" data-id="element-135">68% TOMADOS</span>
              </div>
              <div className="w-full bg-gray-800 rounded-full h-1.5 md:h-2 overflow-hidden" data-id="element-136">
                <motion.div initial={{
                width: 0
              }} whileInView={{
                width: '68%'
              }} viewport={{
                once: true
              }} transition={{
                duration: 1.2,
                ease: 'easeOut'
              }} className="bg-brand-orange h-full rounded-full" data-id="element-137" />
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Header + Selector */}
        <div className="text-center mb-5 md:mb-8" data-id="element-138">
          <h2 className="font-display text-3xl md:text-5xl text-brand-dark" data-id="element-139">
            ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-gray-600 text-sm md:text-base font-medium mt-1 md:mt-2" data-id="element-140">
            Ambas opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        <PricingSelector variant="full" data-id="element-141" />

        {/* PRO Benefits Section */}
        <div className="mt-16 md:mt-32 max-w-5xl mx-auto" data-id="element-142">
          <div className="text-center mb-8 md:mb-16" data-id="element-143">
            <h3 className="text-brand-gold font-bold tracking-widest uppercase text-xs md:text-sm mb-2" data-id="element-144">
              ¿Qué agregan los tomos PRO?
            </h3>
            <h2 className="font-display text-3xl md:text-5xl text-brand-dark leading-tight" data-id="element-145">
              PARA EL PROFE QUE QUIERE IR UN PASO MÁS ALLÁ
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-146">
            {[{
            label: 'Tomo PRO 1',
            title: 'Sin sistema de juego claro',
            sin: 'Cada partido tu equipo juega diferente. Los pibes no saben dónde estar cuando no tienen la pelota.',
            con: 'Sistema ofensivo y defensivo instalado en 4 semanas. Tu equipo juega con criterio y estructura real.'
          }, {
            label: 'Tomo PRO 2',
            title: 'Ningún pibe tuyo llega lejos',
            sin: 'Entrenás bien en grupo pero no tenés un método para detectar y desarrollar al jugador con proyección.',
            con: 'Sistema de detección de talento y plan de desarrollo individual. Tus pibes llegan lejos y te recuerdan siempre.'
          }].map((p, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 15
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white p-5 md:p-8 rounded-2xl border border-gray-200 shadow-sm" data-id="element-147">
                <h4 className="font-bold text-gray-400 uppercase text-[10px] md:text-xs tracking-wider mb-2 md:mb-4" data-id="element-148">
                  Problema que resuelve el {p.label}
                </h4>
                <h3 className="font-display text-xl md:text-2xl text-brand-dark mb-4 md:mb-6 leading-tight" data-id="element-149">
                  {p.title}
                </h3>
                <div className="space-y-3 md:space-y-4" data-id="element-150">
                  <div className="bg-red-50 p-3 md:p-4 rounded-lg border border-red-100" data-id="element-151">
                    <div className="text-red-500 font-bold text-[10px] md:text-xs uppercase tracking-wider mb-1" data-id="element-152">
                      Sin PRO
                    </div>
                    <p className="text-gray-700 text-xs md:text-sm leading-snug" data-id="element-153">
                      {p.sin}
                    </p>
                  </div>
                  <div className="bg-green-50 p-3 md:p-4 rounded-lg border border-green-100" data-id="element-154">
                    <div className="text-green-600 font-bold text-[10px] md:text-xs uppercase tracking-wider mb-1" data-id="element-155">
                      Con PRO
                    </div>
                    <p className="text-gray-800 font-medium text-xs md:text-sm leading-snug" data-id="element-156">
                      {p.con}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>

          {/* Pro Tomos Details */}
          <div className="bg-brand-dark rounded-2xl p-6 md:p-12 border border-brand-gold/20" data-id="element-157">
            <h3 className="font-display text-xl md:text-2xl text-white mb-6 md:mb-8 text-center" data-id="element-158">
              LOS 2 TOMOS PRO INCLUYEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-159">
              {[{
              num: 'PRO 1',
              title: 'El Sistema de Juego Completo',
              desc: 'Sistema ofensivo y defensivo progresivo de Infantil a Juvenil con diagramas, plan de instalación y situaciones especiales.'
            }, {
              num: 'PRO 2',
              title: 'El Entrenador que Forma Jugadores',
              desc: 'Método completo de detección de talento, plan de desarrollo individual y cómo construir una cantera que funcione.'
            }].map((t, i) => <div key={i} className="flex gap-4 md:gap-6" data-id="element-160">
                  <div className="font-display text-2xl md:text-4xl text-brand-gold opacity-50 shrink-0" data-id="element-161">
                    {t.num}
                  </div>
                  <div data-id="element-162">
                    <h4 className="font-bold text-white text-base md:text-xl mb-1 md:mb-2 leading-tight" data-id="element-163">
                      {t.title}
                    </h4>
                    <p className="text-gray-400 text-xs md:text-sm leading-relaxed" data-id="element-164">
                      {t.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}